import { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { FaBell, FaEnvelope } from "react-icons/fa";
import "../../../assets/css/Customer/CustomerSettings/CustomerAppSetting.css";
import CustomerSettingsMasterLayout from "../../../layouts/Customer/CustomerSettingsMasterLayout";

const CustomerAppSetting = () => {
  
  const [emailNotification, setEmailNotification] = useState(true);
  const [inAppNotification, setInAppNotification] = useState(true);

  const settingsData = [
   
    { id: "email", label: "Email Notification", icon: <FaEnvelope />, state: emailNotification, setter: setEmailNotification },
    { id: "inapp", label: "In App Notification", icon: <FaBell />, state: inAppNotification, setter: setInAppNotification },
  ];

  return (
    <CustomerSettingsMasterLayout screenName={"CustomerAppSetting"} centered={true}>
      <div className="customerappsetting-container-wrapper">
        <Container className="customerappsetting-main-card">
          {settingsData.map((item) => (
            <div className="customerappsetting-item" key={item.id}>
              <div className="customerappsetting-left">
                <div className="customerappsetting-icon-box">
                  {item.icon}
                </div>
                <span className="customerappsetting-label">{item.label}</span>
              </div>
              <Form.Check
                type="switch"
                id={item.id}
                checked={item.state}
                onChange={(e) => item.setter(e.target.checked)}
                className="customerappsetting-switch"
              />
            </div>
          ))}
        </Container>
      </div>
    </CustomerSettingsMasterLayout>
  );
};

export default CustomerAppSetting;